import {
  SET_PACKAGE,
  SET_PACKAGE_COUNT,
  SET_PACKAGES_DATA,
} from "../../actions/types/types";

const initState = {
  packageData: {},
  packageInfo: {},
  packages: [],
  packageCount: 0,
  deactivateModalOpen: false,
  selectedSinglePackage: null,
  activateModalOpen: false,
  setPackageToBookAllClassesModalOpen: false,
  appointmentTypes: [],
  packagesForDeduction:[]
};

const PackageReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_PACKAGE:
      return {
        ...state,
        packageData: action.payload.data,
      };
    case SET_PACKAGES_DATA:
      return {
        ...state,
        packages: action.payload.data,
      };
    case "SET_APPOINTMENT_TYPES_DATA":
      return {
        ...state,
        appointmentTypes: action.payload.data,
      };

    case SET_PACKAGE_COUNT:
      return {
        ...state,
        packageCount: action.payload.data,
      };
    case "TOGGLE_DEACIVATE_MODAL_OPEN":
      return {
        ...state,
        deactivateModalOpen: !state.deactivateModalOpen,
      };
    case "SET_SELECTED_SINGLE_PACKAGE":
      return {
        ...state,
        selectedSinglePackage: action.payload.data,
      };
    case "TOGGLE_ACTIVATE_MODAL_OPEN":
      return {
        ...state,
        activateModalOpen: !state.activateModalOpen,
      };
    case "SET_PACKAGE_DATA":
      return {
        ...state,
        packageInfo: action.payload.data,
      };
    case "TOGGLE_SET_PACKAGE_TO_BOOK_ALL_CLASSES_MODAL_OPEN":
      return {
        ...state,
        setPackageToBookAllClassesModalOpen: !state.setPackageToBookAllClassesModalOpen,
      };
      case "SET_PACKAGE_FOR_DEDUCTION":
        return {
          ...state,
          packagesForDeduction: action.payload.data,
        };
      
    default:
      return { ...state };
  }
};

export default PackageReducer;
